import { NgModule } from "@angular/core";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

// components
import { CopyrightComponent } from "./components/copyright.component";
import { AdviceFooterComponent } from "./components/advice-footer.component";

import { ImageSrcPipe } from "./directives/image-src.pipe";

const COMPONENTS = [AdviceFooterComponent, CopyrightComponent, ImageSrcPipe];

@NgModule({
  imports: [CommonModule, RouterModule, ...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class AdviceAidCommonModule {}

export { AdviceFooterComponent, CopyrightComponent, ImageSrcPipe };
